const baseUrl = trimEndSlash(environment.settings["Integrations:SAG:BaseAddress"]);
const env = trimEndSlash(environment.settings["Integrations:SAG:Environment"]);
const sagSubscriptionKey = environment.settings["Integrations:SAG:PublicSubscriptionKey"]; // TODO: don't know if PublicSubscriptionKey or SubscriptionKey

function trimEndSlash(s: string) {
    return s?.replace(/\/*$/, "");
}

function getSagApiUrl(apiName: string) {
    return `${baseUrl}/${apiName}/${env ? env + "/" : ""}`;
}

export default function useSagOptions() {
    return {
        getSagApiUrl,
        sagSubscriptionKey,
    };
}
